import { tidClient } from "./client";

export async function signIn(_args: { email: string; password: string }): Promise<void> {
  // Trimble only supports SSO — email/password sign-in is not available.
  await tidClient?.loginWithRedirect();
}

export async function signInWithRedirect(_args?: { returnTo?: string }): Promise<void> {
  // returnTo is passed via TIDProvider's appState mechanism when called from
  // React (useAuth().loginWithRedirect({ appState: { returnTo } })). Non-React
  // callers of this method do not currently carry a returnTo across the redirect.
  await tidClient?.loginWithRedirect();
}
